import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTimeout from 'react-timeout';
import { isStaticRender } from 'helpers/ContentHelper';
import { now, startOfHour, addHours, differenceInMilliseconds } from 'helpers/DateTimeHelper';

class PrimeTimeUpdater extends Component {
  constructor(props) {
    super(props);
    this.forceUpdate = this.forceUpdate.bind(this);
  }

  componentDidMount() {
    const { setTimeout, timeout } = this.props;
    if (isStaticRender()) return;
    const { forceUpdate } = this;
    setTimeout(() => {
      forceUpdate();
    }, timeout);
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

const nextHourInMS = differenceInMilliseconds(addHours(startOfHour(now()), 1), now());
PrimeTimeUpdater.defaultProps = { timeout: nextHourInMS };

export default ReactTimeout(PrimeTimeUpdater);

PrimeTimeUpdater.defaultProps = {
  children: null,
};

PrimeTimeUpdater.propTypes = {
  children: PropTypes.node,
  setTimeout: PropTypes.func.isRequired,
  timeout: PropTypes.number,
};
